import { DescribeMap, FieldDescribeExtended } from 'app/backend/salesforce-maps/DescribeTypes'

export const getFieldMetadata = (
  describeMap: DescribeMap | null | undefined,
  objectName: string,
  fieldName: string
): FieldDescribeExtended | null => {
  const objectDescribe = describeMap?.[objectName]
  if (objectDescribe == null) return null

  return objectDescribe.fieldsMap?.[fieldName] ?? null
}

export const getFieldMaxLength = (
  describeMap: DescribeMap | null | undefined,
  objectName: string,
  fieldName: string
): number | null => {
  const field = getFieldMetadata(describeMap, objectName, fieldName)

  if (field?.type === 'currency' || field?.type === 'double' || field?.type === 'percent') {
    return field?.precision ?? null
  }

  return field?.length ?? null
}

export const getFieldScale = (
  describeMap: DescribeMap | null | undefined,
  objectName: string,
  fieldName: string
): number => {
  const field = getFieldMetadata(describeMap, objectName, fieldName)
  return field?.scale ?? 0
}

export const allowsDecimals = (
  describeMap: DescribeMap | null | undefined,
  objectName: string,
  fieldName: string
): boolean => {
  const scale = getFieldScale(describeMap, objectName, fieldName)
  return scale > 0
}
